// Formatos y mapeos de estado compartidos por las páginas del dashboard.

const ARS = new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2 });

export function formatMoney(value) {
    const n = Number(value);
    return Number.isFinite(n) ? ARS.format(n) : '-';
}

export function formatDate(iso, opts = { day: '2-digit', month: '2-digit', year: 'numeric' }) {
    if (!iso) return '-';
    return new Date(iso).toLocaleDateString('es-AR', opts);
}

export function formatTime(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
}

// "Hoy 14:32", "Ayer 18:22" o "12/09 10:15"
export function formatWhen(iso) {
    if (!iso) return '-';
    const d = new Date(iso);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const same = (a, b) => a.toDateString() === b.toDateString();
    if (same(d, today)) return `Hoy ${formatTime(iso)}`;
    if (same(d, yesterday)) return `Ayer ${formatTime(iso)}`;
    return `${d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' })} ${formatTime(iso)}`;
}

export function monthLabel(date = new Date()) {
    return date.toLocaleString('es-AR', { month: 'long', year: 'numeric' });
}

export function initials(text = '') {
    return text
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0] || '')
        .join('')
        .toUpperCase() || '?';
}

// invoices.status: 'completada' | 'error' | otro (en proceso)
export function invoiceTone(status, inv) {
    if (inv?.anulada_at) return { tone: 'neutral', label: 'Anulada' };
    if (inv?.nc_de) return { tone: 'ok', label: 'Nota de crédito' };
    if (status === 'completada') return { tone: 'ok', label: 'Completada' };
    if (status === 'error') return { tone: 'danger', label: 'Error' };
    return { tone: 'warn', label: 'Procesando' };
}

// sales_exports.status: 'completado' | 'error' | 'procesando'
export function exportTone(status) {
    if (status === 'completado') return { tone: 'ok', label: 'Completado' };
    if (status === 'error') return { tone: 'danger', label: 'Error' };
    return { tone: 'warn', label: 'Procesando' };
}

// execution_logs.status
export function isLogOk(status) {
    return status === 'success' || status === 'Ejecutado';
}

// afip_credentials.status (null = sin fila)
export const ARCA_STATES = {
    ok: { tone: 'ok', label: 'ARCA conectado', short: 'Conectado' },
    pendiente_validacion: { tone: 'warn', label: 'Validando credenciales', short: 'Validando' },
    error: { tone: 'danger', label: 'Error de conexión con ARCA', short: 'Error' },
    unconfigured: { tone: 'neutral', label: 'ARCA sin configurar', short: 'Sin configurar' },
};

export function arcaState(status) {
    return ARCA_STATES[status] || ARCA_STATES.unconfigured;
}
